<template>
    <div :class="imageClass">
        <div class="images--list">
            <div
                v-for="(img, index) of imageList"
                :key="index"
                ref="list"
                class="images__image"
                :class="imageBorderClass(img)"
                @mouseenter="mouseEnter(index)"
                @mouseleave="mouseLeave()"
            >
                <div v-if="showCheckBox" class="images__checkbox">
                    <input type="checkbox" :checked="img.selected" @change="toggleSelect(img)" />
                </div>
                <div class="images__thumbnail">
                    <div v-show="hoveredIndex === index" class="images__thumbnail--title" @click="openInNewTab(img)">
                        {{ img.note }}
                    </div>
                    <div v-if="allImagesLoaded">
                        <div v-show="hoveredIndex !== index">
                            <img v-if="img.extension !== 'pdf'" width="148" height="70" :src="img.data" />
                            <pdf v-else :src="img.data"></pdf>
                        </div>
                    </div>
                </div>

                <div v-if="hoveredIndex === index" class="images__actions">
                    <button type="button" @click="openInNewTab(img)">
                        {{ $t('common.images.view') }}
                    </button>
                    <button type="button" @click="download(img)">
                        {{ $t('common.images.download') }}
                    </button>
                </div>
                <div v-else class="images__title-wrapper">
                    <div class="images__title">
                        {{ img.note }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="moreCount > 0 && showMoreOption" class="images__more-indicator" @click="toggleMoreBadges">
            <span>+ {{ moreCount }}</span>
        </div>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import FileMixin from 'mixins/FileMixin'
    import cloneDeep from 'lodash.clonedeep'
    export default {
        mixins: [FileMixin],

        components: {
            pdf,
        },

        props: {
            images: { type: Array, required: true },
            showMoreOption: { type: Boolean, default: false },
            showCheckBox: { type: Boolean, default: false },
        },

        data() {
            return {
                hoveredIndex: null,
                moreCount: 0,
                isShowMoreOpen: false,
                imageList: [],
                allImagesLoaded: false,
            }
        },

        computed: {
            imageClass() {
                return {
                    images: !this.showMoreOption,
                    images__calc: this.showMoreOption,
                    images__calc__expanded: this.isShowMoreOpen,
                }
            },
            selectedImages() {
                return this.imageList.filter((img) => img.selected)
            },
        },

        methods: {
            imageBorderClass(img) {
                return {
                    'images__image--selected': img.selected,
                }
            },
            toggleSelect(img) {
                img.selected = !img.selected

                this.$emit('selection-change', this.selectedImages)
            },
            mouseEnter(index) {
                this.hoveredIndex = index
            },

            mouseLeave() {
                this.hoveredIndex = null
            },

            download(file) {
                this.downloadFile(file.url, file.note)
            },

            downloadAll() {
                this.images.forEach((file) => {
                    this.downloadFile(file.url, file.note)
                })
            },

            openInNewTab(file) {
                const routeData = this.$router.resolve({ name: 'image.preview', query: { url: file.url } })
                window.open(routeData.href, '_blank')
            },

            calculateMore() {
                this.$nextTick(() => {
                    const allListElements = this.$refs.list
                    const visibleListElements = []

                    if (!Array.isArray(allListElements)) {
                        return
                    }

                    for (const plan of allListElements) {
                        if (plan.offsetTop === 10) {
                            visibleListElements.push(plan)
                        }
                    }

                    this.moreCount = allListElements.length - visibleListElements.length
                })
            },

            toggleMoreBadges() {
                this.isShowMoreOpen = !this.isShowMoreOpen
            },

            getFilesFromUrl() {
                const promises = []

                for (const img of this.imageList) {
                    const promise = new Promise((resolve, reject) => {
                        this.fetchPrivateBlob(img.url)
                            .then((blob) => {
                                const objectUrl = window.URL.createObjectURL(blob)
                                img.data = objectUrl
                                resolve()
                            })
                            .catch((error) => {
                                reject(error)
                            })
                    })

                    promises.push(promise)
                }

                Promise.all(promises).then(() => {
                    this.allImagesLoaded = true
                })
            },
        },

        watch: {
            moreCount(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.calculateMore()
                }
            },

            images(newValue) {
                this.imageList = cloneDeep(newValue).map((img) => ({
                    ...img,
                    selected: false,
                }))
                this.getFilesFromUrl()
            },
        },

        mounted() {
            this.calculateMore()
            this.imageList = cloneDeep(this.images).map((img) => ({
                ...img,
                selected: false,
            }))
            this.getFilesFromUrl()
            window.addEventListener('resize', this.calculateMore)
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.calculateMore)
        },
    }
</script>
